import React from "react";
import Hero from "../../components/pages/Report/Hero/Hero";
import ReportCorruption from "../../components/pages/Report/ReportCorruption/ReportCorruption";
import "./Report.css";

const Report = () => {
  return (
    <div className="report-page">
      <div className="report-page__grid-section">
        <Hero />
      </div>
      <ReportCorruption />
    </div>
  );
};

export default Report;
